export default __webpack_public_path__ + "static/806-b06d55551bb11025cba06594df0e6205.gif";